class DimensionFilter {
  constructor() {
    this.filterButtons = document.querySelectorAll('.custom-filters-container .custom-filter-button');
    this.filterButtonsMobile = document.querySelectorAll('.custom-filters-container-mobile .custom-filter-button');
    this.productItems = document.querySelectorAll('[data-dimension]');
    this.activeFilter = null;
    this.visibleCountDesktop = document.querySelector('#ProductCountDesktop');
    this.visibleCountMobile = document.querySelector('#ProductCount');
    this.visibleCountDrawer = document.querySelector('.mobile-facets__count');
    this.init();
  }

  init() {
    [...this.filterButtons,...this.filterButtonsMobile].forEach(button => {
      button.addEventListener('click', (e) => this.handleFilterClick(e));
    });
  }

  handleFilterClick(event) {
    const clickedButton = event.currentTarget;
    
    [...this.filterButtons,...this.filterButtonsMobile].forEach(button => {
      button.classList.remove('active-filter');
    });
    
    if (this.activeFilter === clickedButton.dataset.value) {
      this.activeFilter = null;
      this.showAllProducts();
      return;
    }

    clickedButton.classList.add('active-filter');

    const matchingButtons = [...this.filterButtons, ...this.filterButtonsMobile].filter(
      button => button.dataset.value === clickedButton.dataset.value && button !== clickedButton
    );
    matchingButtons.forEach(button => button.classList.add('active-filter'));

    this.activeFilter = clickedButton.dataset.value;
    this.filterProducts();
  }

  filterProducts() {
    let visibleCount = 0;

    this.productItems.forEach(product => {
      const dimensionStr = product.dataset.dimension;

      if (dimensionStr.startsWith(this.activeFilter)) {
        product.classList.remove('hidden-product');
        visibleCount++;
      } else {
        product.classList.add('hidden-product');
      }
    });

    this.updateCounts(visibleCount);
  }

  showAllProducts() {
    let visibleCount = 0;

    this.productItems.forEach(product => {
      product.classList.remove('hidden-product');
      visibleCount++;
    });

    this.updateCounts(visibleCount);
  }

  updateCounts(visibleCount) {
    [this.visibleCountDesktop, this.visibleCountMobile, this.visibleCountDrawer].forEach(element => {
      element.textContent = `${visibleCount} produits`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DimensionFilter();
});
